import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, paddingLevel } from '@styles';
import { Content } from './Content';
import { SimilarProjects } from '@sections/Similar-Projects';
import { addTagsInProject, addTagsInProjects, getSimilarProjects } from '../Gallery-Page/helpers';

export const GalleryProjectPage = ({ projects = [], project = {}, tags = [] }) => {
  const prettyProject = addTagsInProject({ project, tags });
  const similarProjects = getSimilarProjects({ projects, project });
  const prettyProjects = addTagsInProjects({ projects: similarProjects, tags });

  return (
    <Container>
      <Content content={prettyProject} />
      <SimilarProjects projects={prettyProjects} />
    </Container>
  );
};

const Container = styled.div`
  padding-top: 65.4px;
  ${paddingLevel('bottom', 'colar')};
  position: relative;
  z-index: 2;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    background-color: ${Colors.ivory};
    z-index: -1;
  }

  @media ${Points.tablet_portrait} {
    padding-top: 80px;
  }

  @media ${Points.laptop} {
    padding-top: 60px;
  }

  @media ${Points.fullhd} {
    padding-top: 80px;
  }
`;
